import { render, staticRenderFns } from "./MaskaModeluSelect.vue?vue&type=template&id=422cb11d&"
import script from "./MaskaModeluSelect.vue?vue&type=script&lang=js&"
export * from "./MaskaModeluSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports